module.exports = (__webpack_require__(78))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/cjs/react-dom.production.min.js from dll-reference vendor
// module id = 311
// module chunks = 0